export default __webpack_public_path__ + "static/media/logo.e179308d.svg";